
import {Component} from './base';
import * as moment from 'moment';

export class CurrentTimeComponent extends Component {
  public static shouldLoad() {
    return $('.current-time').length > 0;
  }

  public load() {
    // Set timer to update all the current time elements.
    setInterval(this.updateTime, 1000);
    this.updateTime();
  }

  private updateTime() {
    $('.current-time').text(moment().format('HH:mm:ss'));
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/current-time.ts